module.exports = __webpack_public_path__ + "img/jiayin_20210901114733.58ebac60.png";